import { render, staticRenderFns } from "./StatementTitle.vue?vue&type=template&id=ec21f05a&scoped=true&"
import script from "./StatementTitle.vue?vue&type=script&lang=ts&"
export * from "./StatementTitle.vue?vue&type=script&lang=ts&"
import style0 from "./StatementTitle.vue?vue&type=style&index=0&id=ec21f05a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec21f05a",
  null
  
)

component.options.__file = "StatementTitle.vue"
export default component.exports